module.exports = __webpack_public_path__ + "static/media/login-illustration-right.6935300b.svg";